import { put, select } from "redux-saga/effects";

import { createServicedeskRequest } from "model/gql/mutations";

import {
  CREATE_SERVICE_DESK_REQUEST,
  CREATE_SERVICE_DESK_REQUEST_SUCCESS,
  CREATE_SERVICE_DESK_REQUEST_REJECTED,
} from "../../CONSTANTS";

window.testSDRequest = false;

export default function* createSDRequest({ action, config }) {
  try {
    yield put({ type: CREATE_SERVICE_DESK_REQUEST });

    const { gqlclient } = config;
    const userRoles = yield select((state) =>
      state.getIn(["user", "currentUser", "roles"])
    );
    const serviceDeskUserName = userRoles.has("serviceDesk")
      ? userRoles.get("serviceDesk").serviceDeskUserName
      : undefined;

    const { subject, description, category, subcategory } = action.payload;

    if (!serviceDeskUserName) {
      throw new Error(`no serviceDeskUserName in user profile`);
    }

    if (window.testSDRequest) {
      yield put({
        type: CREATE_SERVICE_DESK_REQUEST_SUCCESS,
        payload: {
          success: true,
          message: "test request",
        },
      });
    } else {
      const { data } = yield gqlclient.mutate({
        mutation: createServicedeskRequest.mutation,
        variables: {
          requester: serviceDeskUserName,
          subject,
          description,
          category,
          subcategory,
        },
      });

      if (data.createServicedeskRequest) {
        if (!data.createServicedeskRequest.success) {
          throw new Error(
            `problem with creating request: ${
              data.createServicedeskRequest.message
            }`
          );
        }
        yield put({
          type: CREATE_SERVICE_DESK_REQUEST_SUCCESS,
          payload: {
            success: data.createServicedeskRequest.success,
            message: data.createServicedeskRequest.message,
          },
        });
      } else {
        throw new Error(`no createServicedeskRequest object in response`);
      }
    }
  } catch (e) {
    if (action.payload && action.payload.setError) {
      action.payload.setError(e);
    }
    yield put({
      type: CREATE_SERVICE_DESK_REQUEST_REJECTED,
      payload: { error: e },
    });
  }
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/saga/service-desk/createRequest.js